import { render, staticRenderFns } from "./MainBlog.vue?vue&type=template&id=7c76ab03&scoped=true"
import script from "./MainBlog.vue?vue&type=script&lang=js"
export * from "./MainBlog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c76ab03",
  null
  
)

export default component.exports